import { useLocation } from "react-router-dom";
import MaintenancePage from "./MaintenancePage";

export const MAINTENANCE_EXEMPT_PATHS = new Set([
  "/privacy-policy",
  "/terms-and-conditions",
]);

export const normalizeMaintenancePath = (pathname = "/") => {
  if (pathname === "/") return pathname;
  return pathname.replace(/\/+$/, "") || "/";
};

const MaintenanceGate = ({ children }) => {
  const { pathname } = useLocation();
  const normalizedPath = normalizeMaintenancePath(pathname);

  if (MAINTENANCE_EXEMPT_PATHS.has(normalizedPath)) {
    return children;
  }

  return <MaintenancePage />;
};

export default MaintenanceGate;
